module.exports = __webpack_public_path__ + "img/Success Pad.b4846e4b.png";